import Swiper from 'swiper';

var mainSliderSelector = '.js-slider-image',
    interleaveOffset = 0.5;

var mainText = new Swiper('.js-slider-text', {
      slidesPerView: 1,
      //loop: true,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      effect: 'fade',
      autoHeight: true,
});

// Main Slider
var mainSliderOptions = {
      loop: false,
      speed: 1500,
      initialSlide: 0,
      autoplay:{
        delay:4000
      },
      grabCursor: false,
      watchSlidesProgress: true,
      pagination: {
           el: '.swiper-pagination',
          clickable: true,
		  renderBullet: function (index, className) {
			  return '<div class="' + className + '"><span></span></div>';
		  },
      },
      thumbs: {
        swiper: mainText,
      },
      on: {
        init: function(){
          this.autoplay.stop();
        },
        progress: function(){
          var swiper = this;
          for (var i = 0; i < swiper.slides.length; i++) {
            var slideProgress = swiper.slides[i].progress,
                innerOffset = swiper.width * interleaveOffset,
                innerTranslate = slideProgress * innerOffset;
            swiper.slides[i].querySelector(".slide-bgimg").style.transform =
              "translate3d(" + innerTranslate + "px, 0, 0)";
          }
        },
        setTransition: function(speed) {
          var swiper = this;
          for (var i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = speed + "ms";
            swiper.slides[i].querySelector(".slide-bgimg").style.transition =
              speed + "ms";
          }
        }
      }
    };
var mainSlider = new Swiper(mainSliderSelector, mainSliderOptions);

let sliderReview = new Swiper('.js-slider-review', {
  slidesPerView: 1,
  speed: 1000,
  loop: true,
  navigation: {
    nextEl: '.js-slider-review-next',
    prevEl: '.js-slider-review-prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 1
    },
    480: {
      slidesPerView: 2
    },
    769: {
      slidesPerView: 3
    },
    961: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3
    }

  }
});

let sliderCase = new Swiper('.js-slider-more-case', {
	speed: 1000,
	loop: true,
	spaceBetween: 55,
	navigation: {
		nextEl: '.js-slider-review-next',
		prevEl: '.js-slider-review-prev',
	},
	breakpoints: {
		320: {
			slidesPerView: 1
		},
		480: {
			slidesPerView: 2,
			spaceBetween: 10
		},
		769: {
			slidesPerView: 2
		},
		961: {
			slidesPerView: 2
		},
		1024: {
			slidesPerView: 2
		}

	}
});

let sliderArticles = new Swiper('.js-slider-articles', {
	speed: 1000,
	loop: true,
	spaceBetween: 85,
	navigation: {
		nextEl: '.js-slider-articles-next',
		prevEl: '.js-slider-articles-prev',
	},
	breakpoints: {
		320: {
			slidesPerView: 1
		},
		480: {
			slidesPerView: 2,
			spaceBetween: 20
		},
		769: {
			slidesPerView: 3,
			spaceBetween: 30
		},
		961: {
			slidesPerView: 3,
			spaceBetween: 85
		},
		1024: {
			slidesPerView: 3
		}

	}
});

let sliderNews = new Swiper('.js-slider-news', {
	speed: 1000,
	loop: true,
	spaceBetween: 70,
	navigation: {
		nextEl: '.js-slider-news-next',
		prevEl: '.js-slider-news-prev',
	},
	breakpoints: {
		320: {
			slidesPerView: 1
		},
		480: {
			slidesPerView: 2,
			spaceBetween: 20
		},
		769: {
			slidesPerView: 3,
			spaceBetween: 30
		},
		961: {
			slidesPerView: 4,
			spaceBetween: 70
		},
		1024: {
			slidesPerView: 4
		}

	}
});
